import React from 'react';

export function Skeleton({ w = '100%', h = 14, r = 6 }: { w?: string | number; h?: string | number; r?: string | number }) {
  return <div className="animate-[shimmer_1.4s_infinite] bg-[linear-gradient(90deg,var(--cream-2)_25%,var(--cream-0)_50%,var(--cream-2)_75%)] bg-[length:200%_100%]" style={{ width: w, height: h, borderRadius: r }} />;
}
export type SkeletonProps = React.ComponentProps<typeof Skeleton>;
